import { FC } from "react";
import { twMerge } from "tailwind-merge";
import DisclaimerCloseButton from "./DisclaimerCloseButton";

export interface DisclaimerStripProps {
  disclaimer: string;
  disclaimerId: string;
  customClass?: string;
}

const DisclaimerStrip: FC<DisclaimerStripProps> = ({ disclaimer, disclaimerId, customClass }) => {
  return (
    <div
      id={disclaimerId}
      role="alert"
      className={twMerge(
        "flex items-center bg-[#fef0ca] text-[#1a1a1a] overflow-hidden px-4 py-[12px] md:h-[32px] md:px-4 border-b border-[#cccccc]",
        customClass
      )}
    >
      <div className="flex flex-1 items-center justify-between gap-[8px] min-w-[240px]">
        <div className="flex flex-1 items-center gap-[8px] min-w-[240px]">
          <i className="icomoon before:content-['\e983'] before:text-[20px] w-[20px] h-[20px]" />
          <div className="line-clamp-2 text-xs">{disclaimer}</div>
        </div>
        <DisclaimerCloseButton parentId={disclaimerId} />
      </div>
    </div>
  );
};

export default DisclaimerStrip;
